// Core
// Class
import { Api } from "@/models/class/api.class";
// Interfaces
import { Pagination } from "@/models/constant/interface/common.interface";
import { DetailContactDataDto } from "@/models/interface/contact-data";
import { HeaderListContactDataDto } from "@/models/interface/contact-data/HeaderListContactDataDto.interface";
import { ResponseContactData } from "@/models/interface/contact.interface";
import {
  ErrorResponseModel,
  RequestQueryParamsModel,
} from "@/models/interface/http.interface";
import {
  ContactDataCreateDto,
  ListContactDataDto,
} from "@interface/contact-data";
import { AxiosError } from "axios";
import { HttpClient } from "./HttpClient.service";

export class ContactServices extends HttpClient {
  public constructor() {
    super();
  }

  public listRegionCode(params: RequestQueryParamsModel): Promise<string[]> {
    return this.get<string[]>(Api.Region + "/code", { params })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  public listRegionCity(params: RequestQueryParamsModel): Promise<string[]> {
    return this.get<string[]>(Api.Region + "/city", { params })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  downloadReportContact = (params: RequestQueryParamsModel): Promise<Blob> => {
    return this.get<Blob>(Api.ContactData + `/report`, {
      params,
      responseType: "arraybuffer",
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  };

  /**
   * @deprecated
   * new service {@linkcode getListContactData}
   */
  public listContactData(
    params: RequestQueryParamsModel
  ): Promise<Pagination<ListContactDataDto>> {
    return this.get<Pagination<ListContactDataDto>>(Api.ContactData, { params })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  getListContactData(
    params?: RequestQueryParamsModel
  ): Promise<HeaderListContactDataDto> {
    return this.get<HeaderListContactDataDto>(Api.ContactData, {
      params,
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  public createContactData(
    payload: ContactDataCreateDto
  ): Promise<DetailContactDataDto> {
    return this.post<DetailContactDataDto, ContactDataCreateDto>(
      Api.ContactData,
      payload
    )
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  public updateContactData(
    payload: ContactDataCreateDto,
    id: string
  ): Promise<DetailContactDataDto> {
    return this.put<DetailContactDataDto, ContactDataCreateDto>(
      `${Api.ContactData}/${id}`,
      payload
    )
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  /**
   * @deprecated
   * new service {@linkcode getContactDetail}
   */
  public getContactData(id: string): Promise<ResponseContactData> {
    return this.get<ResponseContactData>(Api.ContactData + `/${id}`)
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  getContactDetail(id: string): Promise<DetailContactDataDto> {
    return this.get<DetailContactDataDto>(Api.ContactData + `/${id}`)
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  syncAllContact(): Promise<boolean> {
    return this.get<boolean>(Api.ContactDataSyncAll)
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }
}
export const contactServices = new ContactServices();
